export default "__VITE_ASSET__C3T3nu97__"